module.exports = "<app-admin-layout [isLogin]=\"globalService.isLogin\"></app-admin-layout>"